(function () {
  'use strict';

  /* @ngdoc object
   * @name importacaoPontoReferencia
   * @description
   *
   */
  angular
    .module('importacaoPontoReferencia', [
      'ui.router'
    ])
    .factory('PontoReferenciaResourceService', Restangular => {
      return Restangular.service('embarque/resources/ponto-referencia/importacoes');
    });
}());
